import { useLayoutEffect, useState } from "react";
import { HEADER_HEIGHT } from "../constants/values";
import { isMobile } from "../utils/helpers";
const MAX_WIDTH = 1200;

const getMapSize = (windowWidth, bottomHeight) => {
  const widthOver1200 = windowWidth > MAX_WIDTH;
  const width = widthOver1200 ? MAX_WIDTH : windowWidth;
  const normalHeight = window.innerHeight - bottomHeight - HEADER_HEIGHT;
  const height = widthOver1200 ? normalHeight * MAX_WIDTH / windowWidth : normalHeight;
  const heightMobile = window.innerHeight * 0.58 - HEADER_HEIGHT;
  return isMobile ? [windowWidth, ~~heightMobile] : [~~width, ~~height];
};

export default function useMapSize(bottomHeight = 200) {
  const [size, setSize] = useState([null, null]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize(getMapSize(window.innerWidth, bottomHeight));
    }

    window.addEventListener("resize", updateSize);
    window.addEventListener("orientationchange", updateSize);
    updateSize();
    return () => {
      window.removeEventListener("resize", updateSize);
      window.addEventListener("orientationchange", updateSize);
    };
  }, [bottomHeight]);
  return size;
}